import { PropsWithChildren, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { ensureSession, hasSessionHint } from 'shared/api/session';
import { useMountEffect } from 'shared/hooks';

/** Resolve the server identity before preferences or a report use account state. A browser that never signed in has none to look up (a page
 * that needs one, a protected route, looks it up itself). */
export default function SessionBootstrap({ children }: PropsWithChildren) {
    const [ready, setReady] = useState(false);
    useMountEffect(() => {
        let current = true;
        if (!hasSessionHint()) { setReady(true); return; }
        void ensureSession().catch(() => undefined).finally(() => { if (current) setReady(true); });
        return () => { current = false; };
    });
    if (!ready) return <Box sx={{ display: 'grid', placeItems: 'center', height: '100vh' }}><CircularProgress aria-label="Checking your session" /></Box>;
    return <>{children}</>;
}
